/* Saved artworks (♡) for wall art (design 2026-10-23, like greatbigcanvas.com's hearts): no account, the handles live in
   this browser's localStorage. Any [data-save="<handle>"] button toggles one; [data-saved-count] shows how many;
   [data-saved-list] (the Saved page, section c365-saved) renders the cards with the section c365-saved-card. */
(() => {
  const KEY = 'c365.saved';
  const MAX = 120;
  const read = () => {
    try {
      const v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v.filter((h) => typeof h === 'string') : [];
    } catch (e) {
      return [];
    }
  };
  const write = (list) => {
    try {
      localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
    } catch (e) {}
  };
  const T = (k, d) => (window.C365_T && window.C365_T[k]) || d;

  const paint = () => {
    const list = read();
    document.querySelectorAll('[data-save]').forEach((b) => {
      const on = list.includes(b.dataset.save);
      b.setAttribute('aria-pressed', String(on));
      b.setAttribute('aria-label', on ? T('saved.remove', 'Remove from saved') : T('saved.add', 'Save this artwork'));
    });
    document.querySelectorAll('[data-saved-count]').forEach((el) => {
      el.textContent = String(list.length);
      el.hidden = list.length === 0;
    });
  };

  const toggle = (h) => {
    const list = read();
    const i = list.indexOf(h);
    if (i >= 0) list.splice(i, 1);
    else list.unshift(h);
    write(list);
    paint();
    return i < 0;
  };

  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-save]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    const on = toggle(b.dataset.save);
    b.classList.remove('is-pop');
    if (on) requestAnimationFrame(() => b.classList.add('is-pop'));
    // on the Saved page, an unsaved card leaves the grid
    const box = b.closest('[data-saved-list] [data-card]');
    if (box && !on) {
      box.remove();
      renderEmpty();
    }
  });
  window.addEventListener('storage', (e) => e.key === KEY && paint());

  // cards that arrive later (filters, rows, pagination) get painted too
  new MutationObserver((recs) => {
    if (recs.some((r) => [...r.addedNodes].some((n) => n.nodeType === 1 && (n.matches('[data-save]') || n.querySelector('[data-save]'))))) paint();
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* Saved page */
  const renderEmpty = () => {
    const root = document.querySelector('[data-saved-list]');
    if (!root) return;
    const n = root.querySelectorAll('[data-card]').length;
    root.closest('[data-saved]').querySelector('[data-saved-empty]').hidden = n > 0;
    const c = root.closest('[data-saved]').querySelector('[data-saved-total]');
    if (c) c.textContent = n ? (n === 1 ? T('saved.one', '1 artwork') : T('saved.other', '__N__ artworks').replace('__N__', n)) : '';
  };
  const renderList = async () => {
    const root = document.querySelector('[data-saved-list]');
    if (!root) return;
    const list = read();
    const html = await Promise.all(
      list.map((h) =>
        fetch(`${window.Shopify?.routes?.root || '/'}products/${encodeURIComponent(h)}?section_id=c365-saved-card`)
          .then((r) => (r.ok ? r.text() : ''))
          .catch(() => null)
      )
    );
    // drop artworks that are gone (404); keep the ones a network error skipped
    const keep = list.filter((h, i) => html[i] !== '');
    if (keep.length !== list.length) write(keep);
    root.innerHTML = html
      .filter(Boolean)
      .map((s) => new DOMParser().parseFromString(s, 'text/html').querySelector('[data-card]')?.outerHTML || '')
      .join('');
    root.removeAttribute('aria-busy');
    paint();
    renderEmpty();
  };

  const init = () => {
    paint();
    renderList();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
